<div class="content-dialog">
    <div class="dialog-header">
        <span>VEHICULO</span>
        <button type="button" class="dialog-header__close" (click)="close()" aria-label="Cerrar">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="dialog-body">

        <div class="intro-banner" *ngIf="flagCreateVehicle === false">
            <span class="intro-banner__icon"><mat-icon>directions_car</mat-icon></span>
            <div class="intro-banner__text">
                <div class="intro-banner__title">Búsqueda de Vehículo</div>
                <div class="intro-banner__subtitle">Seleccione el proyecto y contrato para iniciar el proceso de registro.</div>
            </div>
        </div>

        <form [formGroup]="form" autocomplete="off">

            <div *ngIf="flagCreateVehicle === false">
                <div class="section-label">
                    <span class="section-label__icon"><mat-icon>business</mat-icon></span>
                    <span>PROYECTO O LUGAR DE TRABAJO</span>
                </div>
                <div class="info-card" *ngFor="let proyect of proyectSelected">
                    <img class="info-card__img" src="{{getImg(proyect.Logo)}}" alt="" (error)="commonMetodService._getUrlErrorImg('project', $event)">
                    <div class="info-card__body">
                        <h3 class="info-card__title">{{(proyect.Name | uppercase) || ''}}</h3>
                        <div class="info-card__field">{{proyect.CompanyName || ''}}</div>
                        <div class="info-card__field">{{proyect.CompanyDocNum || ''}}</div>
                    </div>
                    <button type="button" class="info-card__action" (click)="setValue()" aria-label="Cambiar proyecto">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
                <app-select-search class="select-component" style="top: -6px !important;"
                                *ngIf="proyectSelected.length === 0"
                                [_dataSource]="proyects" [textInput]="''" [placeholder]="'Seleccione para buscar el proyecto'" [inputType]="'text'"
                                [dataShow]="'Name'" [dataValue]="'Id'" [otherFilter]="'CompanyDocNum'" [siteCtrl]="controlEmployer"
                                [isCard]="true"
                                [card]="{img: 'Logo', title: 'Name', subTitle: 'CompanyName', finalLeft:'CompanyDocNum'}"
                                (onSelectionChange)="selectedProyect($event)"
                                [onErrorUrl]="'project'">
                </app-select-search>

                <div class="section-label">
                    <span class="section-label__icon"><mat-icon>description</mat-icon></span>
                    <span>CONTRATO</span>
                </div>
                <div class="info-card" *ngFor="let contract of selectedVehicleContracts">
                    <img class="info-card__img" src="{{s3Bucket+getImgContract(contract.FormImageLogo)}}" alt="">
                    <div class="info-card__body">
                        <h3 class="info-card__title">{{(contract.ContractReview | uppercase) || ''}}</h3>
                        <div class="info-card__field">{{contract.ContractorName}}</div>
                        <div class="info-card__field">{{contract.ContractNumber}}</div>
                    </div>
                    <button type="button" class="info-card__action" (click)="setValueContract()" aria-label="Cambiar contrato">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
                <app-select-search class="select-component" *ngIf="selectedVehicleContracts.length === 0"
                                [_dataSource]="vehicleContractsFilter" [textInput]="''" [placeholder]="'Seleccione para buscar el contrato'" [inputType]="'text'"
                                [dataShow]="'ContractorName'" [dataValue]="'Id'" [otherFilter]="'ContractorDocumentNumber'" [siteCtrl]="form.get('ContractId')"
                                [isCard]="true"
                                [card]="{img: 'FormImageLogo', title: 'ContractReview', subTitle: 'ContractorName', finalLeft: 'ContractNumber'}"
                                (onSelectionChange)="onSelectionChangeContract($event)">
                </app-select-search>
            </div>

            <!-- BÚSQUEDA: aún no se ha encontrado/creado el vehículo -->
            <div *ngIf="flagCreateVehicle === false">
                <div class="section-label">
                    <span class="section-label__icon"><mat-icon>directions_car</mat-icon></span>
                    <span>VEHICULO</span>
                </div>

                <div class="field-box doc-type-box">
                    <span class="field-box__label">TIPO DE DOCUMENTO</span>
                    <div class="field-box__control">
                        <mat-icon class="field-box__icon">description</mat-icon>
                        <mat-form-field>
                            <mat-select [(ngModel)]="documentType" [ngModelOptions]="{standalone: true}"
                                        (selectionChange)="onDocumentTypeChange($event.value)">
                                <mat-option *ngFor="let data of vehicleDocumentTypes" [value]="data.Value">
                                    {{data.Description}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="search-row" *ngIf="documentType === 'PLACA'">
                    <div class="field-box search-field--number">
                        <span class="field-box__label">PLACA</span>
                        <div class="field-box__control" style="min-height: 40px;">
                            <mat-form-field>
                                <input matInput type="text" formControlName="LicenseSearch" maxlength="6"
                                       oninput="this.value = this.value.toUpperCase()">
                            </mat-form-field>
                        </div>
                    </div>
                    <button mat-mini-fab class="search-row__btn" matTooltip="buscar" (click)="getVehicleDocument()">
                        <mat-icon>search</mat-icon>
                    </button>
                </div>

                <div class="search-row" *ngIf="documentType === 'REGISTRO_MAQUINARIA'">
                    <div class="field-box search-field--number">
                        <span class="field-box__label">NÚMERO DE REGISTRO (máx. 8 caracteres)</span>
                        <div class="field-box__control" style="width: 158%;">
                            <mat-form-field>
                                <input matInput type="text" formControlName="LicenseNumbersearch" maxlength="8"
                                       oninput="this.value = this.value.toUpperCase()">
                            </mat-form-field>
                            <button type="button" class="field-box__clear" aria-label="Limpiar" (click)="clearLicenseNumberSearch()">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </div>
                    <button mat-mini-fab class="search-row__btn" matTooltip="buscar" (click)="getVehicleDocument()">
                        <mat-icon>search</mat-icon>
                    </button>
                </div>

                <div class="notice-banner">
                    <span class="notice-banner__icon"><mat-icon>info</mat-icon></span>
                    <span>Si el vehículo no se encuentra registrado, el sistema le permitirá iniciar un nuevo flujo de captura de datos después de la búsqueda fallida.</span>
                </div>
            </div>

            <!-- CREACIÓN: el vehículo no fue encontrado, se está registrando uno nuevo -->
            <div *ngIf="flagCreateVehicle === true">

                <div class="upload-photo-row">
                    <img *ngIf="imgCropperResult" class="upload-photo-row__preview" [src]="imgCropperResult" alt="" (click)="updatePhotoVehicle()">
                    <button type="button" class="uploadPhoto" *ngIf="!imgCropperResult" (click)="updatePhotoVehicle()">
                        <mat-icon>file_upload</mat-icon>
                        <div>Cargar Imagen</div>
                    </button>
                </div>

                <div class="field-box field-box--disabled search-field--number" *ngIf="documentType === 'PLACA'">
                    <span class="field-box__label">PLACA</span>
                    <div class="field-box__control">
                        <mat-form-field>
                            <input matInput type="text" formControlName="License" disabled>
                        </mat-form-field>
                    </div>
                </div>

                <div class="field-box field-box--disabled search-field--number" *ngIf="documentType === 'REGISTRO_MAQUINARIA'">
                    <span class="field-box__label">NÚMERO DE REGISTRO</span>
                    <div class="field-box__control">
                        <mat-form-field>
                            <input matInput type="text" formControlName="LicenseNumber" disabled>
                        </mat-form-field>
                    </div>
                </div>

                <div class="field-box">
                    <span class="field-box__label">{{documentType === 'REGISTRO_MAQUINARIA' ? 'TIPO DE MAQUINARIA' : 'TIPO DE VEHÍCULO'}}</span>
                    <div class="field-box__control">
                        <mat-form-field>
                            <mat-select formControlName="VehicleTypeId">
                                <mat-option *ngFor="let data of vehicleTypeFiltered" [value]="data.Id">
                                    {{data.Description}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="field-box">
                    <span class="field-box__label">PAIS</span>
                    <div class="field-box__control">
                        <mat-form-field>
                            <mat-select formControlName="CountryId">
                                <mat-option *ngFor="let data of contries" [value]="data.Value">
                                    {{data.Description}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="field-box">
                    <span class="field-box__label">DESCRIPCIÓN</span>
                    <div class="field-box__control">
                        <mat-form-field>
                            <input matInput type="text" formControlName="Review">
                        </mat-form-field>
                    </div>
                </div>
            </div>

        </form>

        <div class="actions-dialog">
            <button mat-button class="btn-cancelar" (click)="close()">CANCELAR</button>
            <button mat-button *ngIf="flagCreateVehicle === true" class="btn-generar" (click)="save()">GUARDAR</button>
        </div>
    </div>
</div>
